// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { warning } from 'react-notification-system-redux'
import { goBack } from 'react-router-redux'
import { getFormValues } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { getProjectBandOptions } from 'redux/modules/projectSummary'
import { AFS_GRID_FILTER } from 'redux/modules/interferenceAnalysis/constants'

import initializeAFSGridFilter from 'redux/modules/interferenceAnalysis/thunks/initializeAFSGridFilter'
import loadAnalysisSettings from 'redux/modules/interferenceAnalysis/thunks/loadAnalysisSettings'
import { updateInterferenceAnalysisState } from 'redux/modules/interferenceAnalysis/actions'

const initializeInterferenceAnalysis = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        bandOptions,
        selectedBandId,
      } = dispatch(getProjectBandOptions())

      // if there is no selectedBandId, that means
      // that there are no paths in this project that have bands.
      // User definitely shouldn't be here yet in their project's work flow.
      if (selectedBandId === null) {
        const message = 'This project is not yet ready for analysis. No paths were found with bands.'
        dispatch(warning({ message }))

        // send them back one in router history.
        dispatch(goBack())

        // throw here to the caller doesn't think we've initialized properly
        throw new Error(message)
      }

      // loads settings for AFS results colors, analysis types
      await dispatch(loadAnalysisSettings())

      const afsGridFilterValues = getFormValues(AFS_GRID_FILTER)(getState())

      // AFS_GRID_FILTER manages an over arching state throughout the /interference-analysis subtree
      // this form tells us what band and analysis type to be presenting at all times.
      // This form is not destroyed as the user goes through this subtree so we can track
      // those values but the subtree's parent on componentWillUnmount will destory this form
      // so that when we next arrive, it will start with a clean state.
      if (afsGridFilterValues === undefined) {
        await dispatch(initializeAFSGridFilter({
          bandId: selectedBandId,
        }))
      }

      // store band options so we can render them for the form above.
      // and remove all paths from being highlighted.
      // updateAnalysisResults will deal with handling and grid filtering
      // that would be done be filterSelect and filterInput
      await dispatch(updateInterferenceAnalysisState({
        bandOptions,
        highlightedPathIds: [],
      }))
    })
  )
)

export default initializeInterferenceAnalysis
